module.exports = __webpack_public_path__ + "img/20210329_aws_techconnect_series.5512cdce.png";